import React, { FC, useMemo } from "react";
import { ResourceTypeLink } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { LinearProgress, LoadingDescription } from "../styled";

import { useResourceType } from "../../../../hooks/useResourceType";

export const Loading: FC = () => {
  const { t } = useTranslation("dialogs");
  const [resourceType] = useResourceType();
  const template = useMemo(() => t("bulkCopy.loadingDataOf"), [t]);

  const loadingText = useMemo(() => {
    switch (resourceType) {
      case ResourceTypeLink.Project:
        return `${template} ${t("bulkCopy.ofMaps")}...`;
      case ResourceTypeLink.Layer:
        return `${template} ${t("bulkCopy.ofLayers")}...`;
      default:
        return "";
    }
  }, [resourceType, template, t]);

  return (
    <>
      <LoadingDescription>{loadingText}</LoadingDescription>
      <LinearProgress />
    </>
  );
};
